export enum DeliveryDisplayModeEnum {
    SIMPLE = 1,
    DETAILED = 2,
}
